/* eslint-disable import/newline-after-import, import/first */

//region 1. Platform Libraries
import { assert } from 'chai';
import {
    connect,
    createObjectId,
} from 'pow-mongodb-fixtures';
import mongodbURI from 'mongodb-uri';
const request = require('supertest');
//endregion

//region 2. Project Libraries
import DataAPI from '../DataAPI';
//endregion

describe('Route .../live-info', () => {
    const mongo = mongodbURI.parse(process.env.CLIO_MONGO_URL);
    const fixtures = connect(mongo.database, {
        host: mongo.hosts[0].host,
        port: mongo.hosts[0].port,
        user: mongo.username,
        pass: mongo.password,
    });
    const dataAPI = new DataAPI();
    const cameraId = '123456789a123456789b1234';
    const badCameraId = '123456789a123456789b1235';
    const streamIndex = 1;
    const badStreamIndex = 0;
    const rtspUrl = 'rtsp://url';
    const streamerId = '123456789a123456789b1236';
    const streamerIp = '10.140.0.8';

    before(function before(done) {
        this.timeout(5000);
        fixtures.clearAllAndLoad({
            cameras: [{
                _id: createObjectId(cameraId),
                streams: [
                    {},
                    { rtsp_url: rtspUrl },
                ],
            }],
            streamers: [{
                _id: createObjectId(streamerId),
                private_ip: streamerIp,
                port: 15925,
                updated: new Date(),
            }],
        }, (err) => {
            if (err) {
                throw new Error(err.message);
            }
            dataAPI.initialize({
                environment: 'unit-test',
                heartbeatInterval: 10,
                logLevel: 'DEBUG',
                mongoUrl: process.env.CLIO_MONGO_URL,
                port: 15925,
            });
            dataAPI.start(done);
        });
    });

    it('GET existing stream should succeed', (done) => {
        request(dataAPI.expressApp)
            .get(`/cameras/${cameraId}/streams/${streamIndex}/live-info`)
            .expect(200)
            .expect((res) => {
                assert.deepEqual({
                    rtspUrl,
                    streamerUrl: `http://${streamerIp}:15925`,
                    audio: false,
                }, res.body);
            })
            .end(/** @type function */done);
    });

    it('GET non-existing stream should fail', (done) => {
        request(dataAPI.expressApp)
            .get(`/cameras/${cameraId}/streams/${badStreamIndex}/live-info`)
            .expect(500)
            .end(/** @type function */done);
    });

    it('GET non-existing camera should fail', (done) => {
        request(dataAPI.expressApp)
            .get(`/cameras/${badCameraId}/streams/${streamIndex}/live-info`)
            .expect(500)
            .end(/** @type function */done);
    });

    after(done => dataAPI.stop(done));
});
